import { format, startOfDay } from "date-fns";

import type { DateFilter } from "../../../components/DatePeriodSelector/types";
import { DateSelectionMode, OverviewPeriod } from "../../../components/DatePeriodSelector/types";
import { localMidnightTimestamp } from "../../../store/utils/date/calendarDate";
import { getDaysAgoDate } from "../../../store/utils/date/dayAgo";

const SEARCH_PARAM_DATE = "date";
const SEARCH_PARAM_PERIOD = "period";

const PERIOD_7 = "7";
const PERIOD_30 = "30";

/**
 * Parses URL search params into DateFilter.
 * Returns null if params are missing or invalid.
 */
export function parseDateFilterFromSearchParams(
  params: URLSearchParams
): DateFilter | null {
  const dateStr = params.get(SEARCH_PARAM_DATE);
  if (dateStr) {
    const ts = localMidnightTimestamp(dateStr);
    if (!Number.isNaN(ts)) {
      return {
        type: DateSelectionMode.Date,
        dateTs: ts,
      };
    }
  }

  const periodStr = params.get(SEARCH_PARAM_PERIOD);
  if (periodStr === PERIOD_7) {
    return {
      type: DateSelectionMode.Period,
      period: OverviewPeriod.SevenDays,
      startTs: startOfDay(getDaysAgoDate(7)).getTime(),
    };
  }
  if (periodStr === PERIOD_30) {
    return {
      type: DateSelectionMode.Period,
      period: OverviewPeriod.ThirtyDays,
      startTs: startOfDay(getDaysAgoDate(30)).getTime(),
    };
  }

  return null;
}

/**
 * Serializes DateFilter to URL search params (object for setSearchParams).
 */
export function dateFilterToSearchParams(filter: DateFilter): Record<string, string> {
  if (filter.type === DateSelectionMode.Date) {
    return {
      [SEARCH_PARAM_DATE]: format(new Date(filter.dateTs), "yyyy-MM-dd"),
    };
  }
  const period =
    filter.period === OverviewPeriod.ThirtyDays ? PERIOD_30 : PERIOD_7;
  return { [SEARCH_PARAM_PERIOD]: period };
}
